export default __webpack_public_path__ + "static/media/signupleftgraphics.1f07848d.svg";